import { LocaleCode } from 'acscp/translations';

export const getDefaultTimeFormatForLocaleOrFallback = (locale?: LocaleCode): string => {
    switch (locale) {
        case 'en-US':
            return 'h:mm a';
        default:
            return 'HH:mm';
    }
};
